import React from 'react'

const IconBug = ({ style = {}, ...props }) => {
  return (
    <svg
      width="23"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        d="M21.78 14.092c-.868-.32-1.761-.57-2.67-.75a11.681 11.681 0 0 0-.15-1.62 11.371 11.371 0 0 0 2.325-1.252 1.126 1.126 0 0 0-1.32-1.823c-4.117 3-13.32 3-17.43 0a1.125 1.125 0 0 0-1.32 1.823c.724.506 1.504.927 2.325 1.252a11.669 11.669 0 0 0-.15 1.62c-.908.18-1.8.43-2.67.75a1.125 1.125 0 1 0 .81 2.1 14.494 14.494 0 0 1 2.003-.592 11.1 11.1 0 0 0 .397 1.598 10.89 10.89 0 0 0-2.505 2.084 1.135 1.135 0 0 0 1.703 1.5 8.562 8.562 0 0 1 1.732-1.5 7.537 7.537 0 0 0 6.42 3.968 7.538 7.538 0 0 0 6.383-3.997c.642.42 1.225.924 1.732 1.5a1.134 1.134 0 1 0 1.703-1.5 10.89 10.89 0 0 0-2.505-2.085c.172-.522.305-1.056.397-1.598.681.15 1.35.347 2.003.593a1.126 1.126 0 0 0 1.56-1.515 1.125 1.125 0 0 0-.773-.556zm-15.75-.277a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm3.75 6.435a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5.25-3.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM6.54 3.697c.372.51.826.953 1.343 1.313A8.377 8.377 0 0 0 5.22 7.56a17.775 17.775 0 0 0 12.128 0 8.377 8.377 0 0 0-2.663-2.55 5.714 5.714 0 0 0 1.343-1.32 1.41 1.41 0 1 0-1.245-.945 4.215 4.215 0 0 1-1.988 1.5 6.345 6.345 0 0 0-3 0 4.215 4.215 0 0 1-1.987-1.5 1.41 1.41 0 1 0-1.268.952z"
        fill="#FF7675"
      />
    </svg>
  )
}

export default IconBug
